// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingPage_spinnerContainer__TBDZ1"};